import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

// Async action to fetch book same day cleaning list data
export const getForgetPasswordList = createAsyncThunk(
  "forgetPasswordList/getForgetPasswordList",
  async (data, { rejectWithValue }) => {
    try {
      const response = await axios.post(
        `${process.env.REACT_APP_API_URL}/api/auth/forgot-password`,
        data,
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );

      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data || { message: error.message }
      );
    }
  }
);

const forgetPasswordSlice = createSlice({
  name: "forgetPasswordList",
  initialState: {
    loading: false,
    forgetPasswordData: null,
    error: null,
  },
  reducers: {
    ResetForgetPasswordState: (state) => {
      state.loading = false;
      state.forgetPasswordData = null;
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getForgetPasswordList.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getForgetPasswordList.fulfilled, (state, action) => {
        state.loading = false;
        state.forgetPasswordData = action.payload;
      })
      .addCase(getForgetPasswordList.rejected, (state, action) => {
        state.loading = false;
        state.forgetPasswordData = action.payload;
        state.error = action.payload;
      });
  },
});

export const { ResetForgetPasswordState } = forgetPasswordSlice.actions;
export default forgetPasswordSlice.reducer;
